import { Link } from 'react-router-dom';
import { siteConfig, legalLinks, navLinks } from '@/mocks/data';

export default function Footer() {
  const whatsappHref = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent('Merhaba, Atak Sistem Enerji web siteniz üzerinden ulaşıyorum. Bilgi almak istiyorum.')}`;

  return (
    <footer className="bg-secondary-800 text-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl text-background-50">
                Atak <span className="text-accent-400">Sistem</span> Enerji
              </span>
            </Link>
            <p className="text-background-50/60 text-sm leading-relaxed mb-4">
              Balıkesir ve bölge illerde Fineco Isı Pompası, kat kaloriferi ve güneş enerjisi sistemleri alanında profesyonel çözümler.
            </p>
            <p className="text-primary-400 text-xs font-medium">
              Fineco Isı Pompaları Yetkili Bayisi
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">Hızlı Erişim</h4>
            <div className="flex flex-col gap-2">
              {navLinks.slice(1, 7).map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-background-50/60 text-sm hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">İletişim</h4>
            <div className="flex flex-col gap-2.5 text-sm text-background-50/60">
              <a href={`tel:${siteConfig.phoneRaw}`} className="hover:text-primary-400 transition-colors flex items-center gap-2 whitespace-nowrap">
                <i className="ri-phone-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                {siteConfig.phone}
              </a>
              <a href={whatsappHref} target="_blank" rel="noopener noreferrer" className="hover:text-primary-400 transition-colors flex items-center gap-2 whitespace-nowrap">
                <i className="ri-whatsapp-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                WhatsApp'tan Bilgi Al
              </a>
              <span className="flex items-center gap-2">
                <i className="ri-map-pin-2-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                {siteConfig.serviceArea}
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-time-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                {siteConfig.workingHours}
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">Yasal Bilgiler</h4>
            <div className="flex flex-col gap-2">
              {legalLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-background-50/60 text-sm hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-50/40 text-xs">
            &copy; {new Date().getFullYear()} Atak Sistem Enerji. Tüm hakları saklıdır.
          </p>
          <p className="text-background-50/30 text-xs">
            Bu sitede yer alan yasal metinler örnek/placeholder içeriktir. Yasal danışman tarafından kontrol edilmelidir.
          </p>
        </div>
      </div>
    </footer>
  );
}